import React from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "types/store";

import { Grid, AutoSizer } from "react-virtualized";

import { Button } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import ComparisonDashboardChart from "components/Next/Charts/ComparisonDashboardChart";

import NextSearchContainer from "containers/Next/NextSearch";

import * as nextReducer from "containers/Next/NextReducer";
import * as homeReducer from "containers/Home/reducer";
import styles from "./style.module.css";
import PropTypes from "prop-types";
import DashboardFocusModal from "@/components/Next/Dashboard/DashboardFocusModal";
import DashboardRemoveFocusModal from "@/components/Next/Dashboard/DashboardRemoveFocusModal";
import magnifyingGlassChart from "images/magnifying_glass_chart.svg";
import magnifyingGlassMinusChart from "images/magnifying-glass-minus-light-full.svg";
import { cx } from "class-variance-authority";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/aible/Tooltip/Tooltip";
import { isEnabled } from "@/utils/featureFlags";
import LinkedComparisonSelect from "@/components/Next/Dashboard/LinkedComparisonSelect";

const ComparisonDashboard = (props) => {
  return (
    <div className={styles.dashboard}>
      <ReportDashboard {...props} />
    </div>
  );
};

ComparisonDashboard.propTypes = {
  id: PropTypes.number,
  datasetId: PropTypes.number,
  originalId: PropTypes.number,
  hideSearch: PropTypes.bool,
  hideFocusedDeepDive: PropTypes.bool,
  isSmall: PropTypes.bool,
  useReportIdForChatGPTReducer: PropTypes.bool,
  forceShowCharts: PropTypes.bool
};

const ReportDashboard = (props = {}) => {
  const {
    id,
    datasetId,
    originalId,
    hideSearch,
    hideFocusedDeepDive,
    isSmall,
    useReportIdForChatGPTReducer,
    forceShowCharts
  } = props;

  const dispatch = useDispatch();

  const showHiddenCharts = useSelector((state) => nextReducer.getShowHiddenCharts(state, id));

  const charts = useSelector((state) =>
    nextReducer.getComparisonDashboardCharts(state, id, forceShowCharts, undefined, undefined, showHiddenCharts)
  );
  const allCharts = charts.charts;

  const hasCharts = allCharts?.length > 0;

  const [showCreateFocusModal, setShowCreateFocusModal] = useState(false);
  const [showRemoveFocusModal, setShowRemoveFocusModal] = useState(false);
  const [selectedFocusedChart, setSelectedFocusedChart] = useState(undefined);

  const handleCloseCreateFocusedModal = () => {
    setShowCreateFocusModal(false);
    setSelectedFocusedChart(undefined);
  };

  const handleOpenCreateFocusedModal = (chart) => {
    setShowCreateFocusModal(true);
    setSelectedFocusedChart(chart);
  };

  const handleCloseRemoveFocusedModal = () => {
    setShowRemoveFocusModal(false);
    setSelectedFocusedChart(undefined);
  };

  const handleOpenRemoveFocusedModal = (chart) => {
    setShowRemoveFocusModal(true);
    setSelectedFocusedChart(chart);
  };

  /*
          <AutoSizer>
            {({ height, width }) => {
              const minColumnWidth = 310;
              const columnCount = Math.floor((width - 50) / minColumnWidth);
              const columnWidth = Math.floor((width - 50) / columnCount);
              const rowCount = Math.ceil(cards.length / columnCount);

              return (
                <Grid
                  cellRenderer={(props) => <RenderCard {...props} columnCount={columnCount} cards={cards} />}
                  columnCount={columnCount}
                  columnWidth={columnWidth}
                  height={height}
                  rowCount={rowCount}
                  rowHeight={330}
                  width={width}
                />
              );
            }}
          </AutoSizer>
    */

  return (
    <>
      <div className={styles.iDashboard}>
        {!hideSearch && (
          <div className={styles.nextSearch}>
            <NextSearchContainer id={id} isOnlySearch isDashboard originalId={originalId} />
          </div>
        )}
        {!hasCharts ? (
          <div className={styles.loadHolder}>{"No Charts Found"}</div>
        ) : (
          <div
            className={styles.botCharts}
            style={{
              paddingBottom: "0px",
              paddingRight: "0px",
              paddingLeft: "0px",
              paddingTop: isSmall ? "0px" : undefined
            }}
          >
            {!hideFocusedDeepDive && (
              <LinkedComparisonSelect
                id={id}
                style={{
                  minWidth: "200px",
                  width: "100%",
                  paddingTop: "10px",
                  paddingLeft: "20px",
                  paddingRight: "20px"
                }}
                forceActiveTab={"DASHBOARD"}
              />
            )}
            <div className={styles.comparisonBotLeft}>
              <AutoSizer>
                {({ height, width }) => {
                  const minColumnWidth = 310;
                  const columnCount = 3;
                  const columnWidth = minColumnWidth;
                  const rowCount = Math.ceil(allCharts.length / columnCount);

                  return (
                    <Grid
                      cellRenderer={(props) => (
                        <RenderVirtualChart
                          {...props}
                          nextId={id}
                          useReportIdForChatGPTReducer={useReportIdForChatGPTReducer}
                          columnCount={columnCount}
                          charts={allCharts}
                          hideFocusedDeepDive={hideFocusedDeepDive}
                          handleOpenCreateFocusedModal={handleOpenCreateFocusedModal}
                          handleOpenRemoveFocusedModal={handleOpenRemoveFocusedModal}
                        />
                      )}
                      columnCount={columnCount}
                      columnWidth={width / 3}
                      height={height}
                      rowCount={rowCount}
                      rowHeight={isSmall ? height * 0.8 : height * 0.6}
                      width={width}
                    />
                  );
                }}
              </AutoSizer>
              {/*
              {allCharts.map((chart, i) => {
                const isCreating = isLinkedComparisonCreating?.[chart?.title] === true;

                const focusNextId = linkedComparisonProjects?.[chart?.title];

                return (
                  <div
                    className={cx(styles.dashboardChartInfographic, styles.isComparison, "group")}
                    style={{
                      width: isSmall ? "calc(50% - 20px)" : undefined,
                      position: "relative"
                    }}
                    key={"dash_left_" + i}
                  >
                    {isEnabled("focused_whats_changed") && (
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <div
                            style={{ position: "absolute", top: "10px", right: "10px", zIndex: 1 }}
                            className="invisible group-hover:visible"
                          >
                            <Button
                              onClick={
                                focusNextId !== undefined
                                  ? () =>
                                      dispatch(
                                        nextReducer.openComparisonProject(linkedComparisonProjects?.[chart?.title])
                                      )
                                  : isCreating
                                    ? () => {}
                                    : () => handleOpenCreateFocusedModal(chart)
                              }
                              style={{ padding: "6px 15px" }}
                              disabled={isCreating === true}
                            >
                              {isCreating ? (
                                <LoadingIndicator
                                  style={{
                                    height: "20px",
                                    width: "20px",
                                    right: "9px",
                                    bottom: "8px",
                                    margin: "0px",
                                    transform: "scale(0.4)"
                                  }}
                                />
                              ) : (
                                <img src={magnifyingGlassChart} style={{ width: "20px", height: "20px" }} />
                              )}
                            </Button>
                          </div>
                        </TooltipTrigger>
                        <TooltipContent>
                          {focusNextId !== undefined
                            ? "Open Focused What's Changed"
                            : isCreating
                              ? "Creating..."
                              : "Create Focused What's Changed"}
                        </TooltipContent>
                      </Tooltip>
                    )}
                    <ComparisonDashboardChart
                      id={id}
                      reportId={id}
                      chart={chart}
                      dataset={dataset}
                      datasetSuccess={datasetSuccess}
                      sortType={sortType}
                    />
                  </div>
                );
              })}
              */}
            </div>
          </div>
        )}
      </div>
      <DashboardFocusModal
        id={id}
        handleClose={handleCloseCreateFocusedModal}
        chart={selectedFocusedChart}
        open={showCreateFocusModal}
      />
      <DashboardRemoveFocusModal
        id={id}
        handleClose={handleCloseRemoveFocusedModal}
        chart={selectedFocusedChart}
        open={showRemoveFocusModal}
      />
    </>
  );
};

const RenderVirtualChart = (props) => {
  const {
    nextId,
    columnIndex,
    rowIndex,
    style,
    charts,
    columnCount,
    handleOpenCreateFocusedModal,
    handleOpenRemoveFocusedModal,
    hideFocusedDeepDive,
    useReportIdForChatGPTReducer,
    ...retProps
  } = props;

  const dispatch = useDispatch();

  const datasetId = useSelector((state) => nextReducer.getDatasetId(state, datasetId));
  const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
  const datasetSuccess = useSelector((state) => nextReducer.getDatasetSuccess(state, nextId));

  const sortType = useSelector((state) => nextReducer.getComparisonDashBoardSort(state, nextId));

  const linkedComparisonProjects = useSelector((state) => nextReducer.getLinkedComparisonProjects(state, nextId)) ?? {};
  const isLinkedComparisonCreating =
    useSelector((state) => nextReducer.getIsLinkedComparisonCreating(state, nextId)) ?? {};

  const index = rowIndex * columnCount + columnIndex;
  const chart = charts?.[index];

  const isHidden = useSelector((state) => nextReducer.getIsChartHidden(state, nextId, chart?.title, true));

  const isCreating = isLinkedComparisonCreating?.[chart?.title] === true;

  const focusNextId = linkedComparisonProjects?.[chart?.title];

  const isFocusExist = focusNextId !== undefined;

  return chart === undefined ? (
    <div />
  ) : (
    <div style={style}>
      <div
        className={cx(styles.dashboardChartInfographicVirtual, styles.isComparison, "group")}
        key={"dash_left_" + index}
      >
        <div
          style={{ position: "absolute", top: "10px", right: "30px", zIndex: 1, display: "flex", alignItems: "center" }}
          className="invisible group-hover:visible"
        >
          <Button
            onClick={() => {
              dispatch(nextReducer.updateIsChartHidden(nextId, chart?.title, !isHidden));
            }}
            style={{ padding: "6px 15px", marginRight: "10px" }}
          >
            <div style={{ height: "20px" }}>{isHidden ? "Show" : "Ignore"}</div>
          </Button>
          {isFocusExist && (
            <Button
              onClick={() => {
                dispatch(nextReducer.openComparisonProject(linkedComparisonProjects?.[chart?.title]));
              }}
              style={{ padding: "6px 15px", marginRight: "10px" }}
            >
              <div style={{ height: "20px" }}>{"Open"}</div>
            </Button>
          )}
          {isEnabled("focused_whats_changed") && !hideFocusedDeepDive && (
            <Tooltip>
              <TooltipTrigger asChild>
                <div>
                  <Button
                    onClick={() => {
                      if (isCreating) return;
                      if (isFocusExist) {
                        handleOpenRemoveFocusedModal(chart);
                      } else {
                        handleOpenCreateFocusedModal(chart);
                      }
                    }}
                    style={{ padding: "6px 15px" }}
                    disabled={isCreating}
                  >
                    {isCreating ? (
                      <LoadingIndicator
                        style={{
                          height: "20px",
                          width: "20px",
                          right: "9px",
                          bottom: "8px",
                          margin: "0px",
                          transform: "scale(0.4)"
                        }}
                      />
                    ) : (
                      <img
                        src={isFocusExist ? magnifyingGlassMinusChart : magnifyingGlassChart}
                        style={{ width: "20px", height: "20px" }}
                      />
                    )}
                  </Button>
                </div>
              </TooltipTrigger>
              <TooltipContent>
                {isFocusExist
                  ? "Remove Focused What's Changed"
                  : isCreating
                    ? "Creating..."
                    : "Create Focused What's Changed"}
              </TooltipContent>
            </Tooltip>
          )}
        </div>
        <ComparisonDashboardChart
          id={nextId}
          reportId={nextId}
          useReportIdForChatGPTReducer={useReportIdForChatGPTReducer}
          chart={chart}
          dataset={dataset}
          datasetSuccess={datasetSuccess}
          sortType={sortType}
        />
      </div>
    </div>
  );

  return (
    <div className={styles.marketGridCell} key={columnIndex + "__" + rowIndex} style={style}>
      {chart && <MarketItemCard {...card} />}
    </div>
  );
};

export default ComparisonDashboard;
